import {
  faCheck,
  faTimes,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import axios from "../../../api/axios";
import useAuth from "../../../hooks/useAuth";

const TableCustom = ({ refresh, axiosData, editUser }) => {
  const [data, setData] = useState([]);
  const DELETE_URL = "/users";
  const { auth } = useAuth();
  const [companyid, setCompanyId] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    refresh();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  useEffect(() => {
    setData(axiosData);
  }, [axiosData]);

  const deleteUser = async (id) => {
    try {
      setShow(false);
      const moderator = data.find(values=>values._id === id)
      const response = await axios.delete(`${DELETE_URL}/${Object.values(moderator.roles).includes(1984) ? 'moderator/' : '' }${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth?.accessToken,
        },
      });
      // TODO: remove console.logs before deployment
      setData(data.filter((value) => value._id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  const editValues = (e) => {
    const id = e.currentTarget.attributes.datakey.nodeValue;
    editUser({
      username: data[id].username,
      pwd: data[id].pwd,
      email: data[id].email,
      phone: data[id].phone,
      pwdValid: data[id].pwd,
      id: data[id]._id,
      roles:Object.values(data[id].roles).includes(1984) ? true : false,
      nro_tambo:data[id].nro_tambo
    });
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Acción</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Realmente desea eliminar el usuario?</Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-danger" onClick={() => setShow(false)}>
            <FontAwesomeIcon icon={faTimes} />
          </Button>
          <Button
            className="btn btn-success"
            onClick={() => deleteUser(companyid)}
          >
            <FontAwesomeIcon icon={faCheck} />
          </Button>
        </Modal.Footer>
      </Modal>
      <Table striped hover size="sm" responsive>
        <thead className="table-green">
          <tr>
            <th scope="col" filterby="name">
              Nro. Tambo
            </th>
            <th scope="col" filterby="cuit">
              E-mail
            </th>
            <th scope="col" filterby="user">
              Usuario
            </th>
            <th scope="col" filterby="pass">
              Contraseña
            </th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index} style={{ cursor: "pointer" }}>
              <td datakey={index} onClick={editValues}>
                {Object.values(row.roles).includes(1984) ? 'Administrador': row.nro_tambo}
              </td>
              <td datakey={index} onClick={editValues}>
                {row.email}
              </td>
              <td datakey={index} onClick={editValues}>
                {row.username}
              </td>
              <td datakey={index} onClick={editValues}>
                {row.pwd}
              </td>
              <td className=" text-center" datakey="action">
                <button
                  className="btn btn-danger"
                  id={row._id}
                  onClick={(e) => {
                    setCompanyId(e.currentTarget.id);
                    setShow(true);
                  }}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {data.length === 0 && (
        <h6 className="text-center mt-3">
          No se encontraron usuarios en la base de datos
        </h6>
      )}
    </>
  );
};

export default TableCustom;
